module.exports = __webpack_public_path__ + "static/media/YM40_3.eda6079c.jpg";